




import Vue from 'vue';
import ProcessingStatusOrganizationsDetail from '@/components/processing-status-organizations/processing-status-organizations-detail.component.vue';

export default Vue.extend({
  components: {
    'processing-status-organizations-detail':
      ProcessingStatusOrganizationsDetail,
  },
});
